import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SettingsService } from '@core/bootstrap';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
})
export class BrandingComponent {
  @Input() showName = true;

  constructor(private readonly _settings: SettingsService) {}

  get collapsed(): boolean {
    if (this._settings.options.sidenavCollapsed) {
      return true;
    }
    return false;
  }

  get wordLogo(): string {
    return this._settings.getSchemeColor() === 'dark'
      ? 'Reengage_Green.svg'
      : 'Reengage_Black.svg';
  }
}
